/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext } from "react";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

const ContactCardComponentDisplay = () => {

    const { component } = useContext(ContentZoneContext);
    const title = component?.title;
    const subtitle = component?.subtitle;
    const contactList = component?.contact_list || [];

    const hasContent = contactList.length > 0 || title || subtitle;

    return (
        <div className="simplicity-contact-card">
            {hasContent && (
                <div className="contact-card-content">
                    {(title || subtitle) && (
                        <div className="contact-card-header">
                            {title && <h3 className="contact-card-title">{title}</h3>}
                            {subtitle && <p className="contact-card-subtitle">{subtitle}</p>}
                        </div>
                    )}
                    <div className='contact-card-container'>
                        {contactList.map((contactItem, index) => (
                            <div key={index} className="contact-card-item">
                                {contactItem?.logo && (
                                    <a className="contact-card-logo" href={contactItem?.url} target="_blank" rel="noopener noreferrer">
                                        <img src={contactItem.logo} alt="Contact Logo" />
                                    </a>
                                )}
                                <div className="contact-card-info">
                                    {contactItem?.orgName && (
                                        <h4 className="contact-card-orgname">{contactItem.orgName}</h4>
                                    )}
                                    {contactItem?.email && (
                                        <p className="contact-card-email">
                                            <a href={`mailto:${contactItem.email}`}>{contactItem.email}</a>
                                        </p>
                                    )}
                                    {contactItem?.phone && (
                                        <p className="contact-card-phone">
                                            <a href={`tel:${contactItem.phone}`}>{contactItem.phone}</a>
                                        </p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {!hasContent && (
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            )}
        </div>
    );
};

ContactCardComponentDisplay.displayName = "ContactCardComponentDisplay";
export { ContactCardComponentDisplay };
